import { lazyLoad } from "utils/loadable";

const ActivitiesPage = lazyLoad(
  () => import("./index"),
  (module) => module.ActivitiesPage,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default ActivitiesPage;
